import axios from 'axios'
import router from '@/router/index'
import ElementUI from 'element-ui'
import store from '@/store/index'
 
const request = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API,
})

// 请求拦截
request.interceptors.request.use(
  (config) => {
    if(localStorage.getItem('userToken') ) {
      config.headers.token = localStorage.getItem('userToken') 
    }
    return config
  },
  (err) => Promise.reject(err)
)

request.interceptors.response.use(
  (response) => {
    if (response.data.code =='-100'&&response.data.login_skip_url == "login") {
      ElementUI.Message({type:'error',message:response.data.msg})
      setTimeout(() => {
         router.push('/login')
      }, 1000);
     
      return false;
      console.log('0000')
      // TODO
    }else if(response.data.code =='tingjiweihu'){
      setTimeout(() => {
        router.push('/closingdown')
     }, 100);
     return {statusCode:50,message:'',info:{list:[],condition:[]}};
    }else{
      return response.data
    }
    
   
  },
  (error) => Promise.reject(error)
)

export default request